export const PURCHASE_ORDER_TTL_ES = 'Orden de Compra';

export interface IPurchaseOrderBase {
  id: number;
}

export interface IPurchaseOrder {
  document: {
    providerId: number;
    delivery_at: Date;
    paymentTermsId: number;
    taxId: number;
    orderStatusId: number;
    receptionStatusId: number;
    invoiceStatusId: number;
  };

  products: [
    {
      purchaseOrderDocumentId: number;
      productOfProviderId: number;
      name: string;
      unitMeasure: string;
      quantity: number;
      quantity_rejected: number;
      quantity_received: number;
      quantity_invoiced: number;
      unitPrice: number;
      discount: number;
      netTotal: number;
      tax: number;
      totalTax: number;
      grossTotal: number;
    }
  ];
}

export interface ProductsPurchaseOrderBody {
  productOfProviderId: number;
  name: string;
  unitMeasure: string;
  quantity: number;
  quantity_rejected: number;
  quantity_received: number;
  quantity_invoiced: number;
  unitPrice: number;
  discount: number;
  netTotal: number;
  tax: number;
  totalTax: number;
  grossTotal: number;
}

export const IdentifierTypeOrderStatus /*: OrderStatusType[]*/ = [
  { id: 1, name: 'BOSQUEJO' },
  { id: 2, name: 'APROBADO' },
  { id: 3, name: 'RECHAZADO' },
  { id: 4, name: 'REVISADO' },
  { id: 5, name: 'COMPLETADO' }
];

export const IdentifierTypeReceptionStatus /*: ReceptionStatusType[]*/ = [
  { id: 1, name: 'NO RECIBIDO' },
  { id: 2, name: 'PARCIALMENTE RECIBIDO' },
  { id: 3, name: 'RECIBIDO' }
];

export const IdentifierTypeInvoiceStatus /*: InvoiceStatusType[] */ = [
  { id: 1, name: 'NO FACTURADO' },
  { id: 2, name: 'PARCIALMENTE FACTURADO' },
  { id: 3, name: 'FACTURADO' }
];

export const ORDERSTATUS_ID = {
  1: 'BOSQUEJO',
  2: 'APROBADO',
  3: 'RECHAZADO',
  4: 'REVISADO',
  5: 'COMPLETADO'
};
export const RECEPTIONSTATUS_ID = {
  1: 'NO RECIBIDO',
  2: 'PARCIALMENTE RECIBIDO',
  3: 'RECIBIDO'
};
export const INVOICESTATUS_ID = {
  1: 'NO FACTURADO',
  2: 'PARCIALMENTE FACTURADO',
  3: 'FACTURADO'
};
